import React, { useEffect, useRef } from 'react';

const SIMPLECAST_EPISODE_ID = '4251d893-2fc1-4d52-9a45-d0cfed1c0f9a';
const SIMPLECAST_COLOR = '08364C';

const AudioTest: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  // Simplecast recommended: load their embed script once
  useEffect(() => {
    const scriptId = 'simplecast-embed-sdk';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://embed.simplecast.com/embed.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="w-full max-w-3xl mx-auto px-2 sm:px-4 md:px-6 py-4 sm:py-6 md:py-8">
      {/* Header */}
      <div className="mb-4 sm:mb-6">
        <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-brand-text-primary">
          Audio Test
        </h1>
        <p className="text-sm sm:text-base text-brand-text-secondary mt-1">
          Embedded podcast episode via Simplecast
        </p>
      </div>

      {/* Audio player container */}
      <div
        ref={containerRef}
        className="w-full rounded-lg overflow-hidden shadow-lg bg-brand-surface"
      >
        {/*
          Simplecast iframe embed — best-practice approach:
          • Use the /iframe path for a clean, no-JS-required embed 
          • dark=true for dark theme
          • hide_share=true to declutter the UI
          • color param for brand accent
          • Fixed 200px height (Simplecast standard for single-episode players)
        */}
        <iframe
          src={`https://player.simplecast.com/${SIMPLECAST_EPISODE_ID}?dark=true&hide_share=true&color=${SIMPLECAST_COLOR}`}
          width="100%"
          height="200"
          frameBorder="0"
          scrolling="no"
          seamless
          allow="autoplay; encrypted-media"
          title="Simplecast Audio Player"
          className="block w-full"
          style={{ minHeight: 200 }}
          loading="lazy"
        />
      </div>

      {/* Accessibility / fallback link */}
      <p className="mt-3 text-xs sm:text-sm text-brand-text-tertiary text-center">
        If the player does not load,{' '}
        <a
          href={`https://player.simplecast.com/${SIMPLECAST_EPISODE_ID}`}
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-brand-primary hover:text-brand-primary-hover transition-colors duration-200"
        >
          listen directly on Simplecast
        </a>
        .
      </p>
    </div>
  );
};

export default AudioTest;
